export const common = {
  UPLOAD_NF: {
    URL: "https://462bjc2clj.execute-api.sa-east-1.amazonaws.com/v0/api/file/",
    KEY: "kUy3VrAtEwa2OkvLIVDB969ACW64OU9OfsZKJGPi"
  }
};
